import { render } from "./TrafficGroups.vue?vue&type=template&id=e30975a0&ts=true"
import script from "./TrafficGroups.vue?vue&type=script&lang=ts"
export * from "./TrafficGroups.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__